import { layout } from '../../App.routing'

export const jabTrackerSegment = ({ contentApi }: { contentApi: string }) => {
    return layout.component({
        type: 'jab-tracker',
        props: {
            contentApi: contentApi,
            ratios: {
                mobile: 1,
                tablet: 1,
                desktop: 0.75,
            },
        },
    })
}
